import { Component, OnInit } from '@angular/core';
import { PageTitleService } from '../core/page-title/page-title.service';
import { ChkService } from '../service/chk.service';
import * as L from 'leaflet';

import { LatLng, tileLayer } from 'leaflet';
@Component({
  selector: 'angly-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  /* Variables */
  contact : any;

  lat: number = 30.67995;
  lng: number = 76.72211;
  defaultMapCenter: LatLng = new LatLng(40.531018135031296, 17.434091644128326);
  map!: L.Map;
  constructor( private pageTitleService: PageTitleService, private service:ChkService ) {

	 /* Page title */
	 this.pageTitleService.setTitle(" Lets Get In Touch ");

	 /* Page subTitle */
	 this.pageTitleService.setSubTitle(" Contatti ");

	 this.service.getContactContent().
		subscribe(response => {this.contact = response},
					 err      => console.log(err),
					 ()       => this.contact
				);
  }

  ngOnInit() {
  }
  
  options = {
    layers: [
       tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' })
    ],
    zoom: 13,
    center: this.defaultMapCenter
 };

  // get the reference to the map
  onMapReady(map: L.Map) {
    this.map = map;
  } 
}
